import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { getAsset } from 'src/utils';
import { useMenuContext } from '../context';
import { TMenuAddress, TMenuContact, TMenuWhitelabel } from '../types';

type Props = {
  whitelabel?: TMenuWhitelabel;
  contact?: TMenuContact;
  address?: TMenuAddress;
  isBM?: boolean;
  sendToGA: (type: string, obj: any, isMultiPaths?: boolean) => void;
};

export const BottomSection = ({ whitelabel, contact, address, isBM, sendToGA }: Props) => {
  const { colors, translation } = useMenuContext();

  return (
    <Stack
      sx={{
        width: '100%',
        marginTop: 'auto',
        padding: 1,
      }}
      spacing={1}
    >
      {contact?.phone && isBM && (
        <Button
          sx={{
            borderRadius: 1,
            background: colors.btnBg,
            color: colors.btnText,
            textTransform: 'none',
            '&:hover': {
              background: colors.btnHover,
              color: colors.btnText,
            },
          }}
          fullWidth
          startIcon={<i className="fas fa-envelope" style={{ fontSize: '14px' }} />}
          onClick={() => {
            sendToGA('event', {
              eventCategory: 'GetInTouch',
              eventAction: 'click',
            });
            contact.onClick();
          }}
        >
          {translation?.getInTouch || 'Get In Touch'}
        </Button>
      )}
      {address && address.label && isBM && (
        <Button
          fullWidth
          variant="text"
          startIcon={<i className="fas fa-map-marker-alt" style={{ fontSize: '14px' }} />}
          onClick={address.onClick}
          sx={{
            color: colors.text,
            textTransform: 'none',
          }}
        >
          {address.label}
        </Button>
      )}
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="center"
        sx={{
          color: colors.text,
          background: colors.bg,
          marginLeft: '-8px !important',
          marginRight: '-8px !important',
          marginBottom: '-8px !important',
          borderRadius: '0 0 0 10px',
          paddingY: 0.5,
          paddingX: 2,
          height: '36px',
        }}
      >
        <Typography
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          {translation?.producedBy || 'Produced By'}
        </Typography>
        <Link
          rel="noreferrer"
          target="_blank"
          href={whitelabel?.website}
          sx={{
            display: 'flex',
          }}
          onClick={() => {
            sendToGA('event', {
              eventCategory: 'ProducedBy',
              eventAction: 'click',
            });
          }}
        >
          <Box
            component="img"
            src={whitelabel?.logo || getAsset('logo-white.svg')}
            sx={{
              maxHeight: '30px',
              width: '100%',
              objectFit: 'contain',
            }}
          />
        </Link>
      </Stack>
    </Stack>
  );
};
